import type { KeyTextField } from '@prismicio/client';
import { memo } from 'react';
import styles from './paragraph.module.scss';

interface ParagraphProps {
  content: KeyTextField;
}

const ParagraphComponent = ({ content }: ParagraphProps) => {
  return <p className={styles.paragraph}>{content}</p>;
};

export const Paragraph = memo(ParagraphComponent);
